<template>
    <ajax-form
        :action="action"
        @submitted="trackFormEvent"
        @error="$EventBus.$emit('resetCaptcha')"
    >
        <slot />
    </ajax-form>
</template>

<script>
    import AjaxForm from './AjaxForm';

    export default {
        components: {
            AjaxForm,
        },
        props: {
            action: {
                type: String,
                required: true,
            },
            formName: {
                type: String,
                default: '',
            },
        },
        methods: {
            trackFormEvent() {
                this.$GtmTracker.formSubmission(this.formName);
            },
        },
    };
</script>
